import React, { useEffect, useState, useRef } from 'react';
import { ModalComp, KeyLamp } from "../";
import { WidgetCommands, ScheduleList, WidgetSetting, EditWidget, MoveWidget, InfoWidget, DeviceInfo, LearnWidget } from "./";
import { FaEyeSlash, FaEye, FaQuestion } from "react-icons/fa";

const WidgetRadio = ({ zone, isPhone, show, sendWidgetCommand, health, showAll, setShowFreezing }) => {
    const radioinput = useRef();
    const [value, setValue] = useState(0);
    const [openKeyLampModal, setOpenKeyLampModal] = useState(false);
    const toggleKeyLamp = () => {
        setOpenKeyLampModal(!openKeyLampModal);
    }
    const openKeyLamp = () => {
        // if (!edit) {
        if (isPhone && window.orientation === 0) {
            toggleKeyLamp();
        } else {
            show("keyLamp");
        }
        // }
    }
    const [hideWidget, setHideWidget] = useState(false);
    const [widgetSettingOpen, setWidgetSettingOpen] = useState(false);
    const toggleWidgetSetting = () => setWidgetSettingOpen(!widgetSettingOpen);
    const [openCommandsModal, setOpenCommandsModal] = useState(false);
    const toggleCommands = () => setOpenCommandsModal(!openCommandsModal);
    const [openEditModal, setOpenEditModal] = useState(false);
    const toggleEdit = () => setOpenEditModal(!openEditModal);
    const [openMoveModal, setOpenMoveModal] = useState(false);
    const toggleMove = () => setOpenMoveModal(!openMoveModal);
    const [openScheduleListModal, setOpenScheduleListModal] = useState(false);
    const toggleScheduleList = () => setOpenScheduleListModal(!openScheduleListModal);
    const [openInfoModal, setOpenInfoModal] = useState(false);
    const toggleInfo = () => setOpenInfoModal(!openInfoModal);
    const [openDeviceInfoModal, setOpenDeviceInfoModal] = useState(false);
    const toggleDeviceInfo = () => setOpenDeviceInfoModal(!openDeviceInfoModal);
    const [openLearnModal, setOpenLearnModal] = useState(false);
    const toggleLearn = () => setOpenLearnModal(!openLearnModal);
    let inputRange;

    useEffect(() => {
        inputRange = radioinput.current;
        inputRange.addEventListener('touchend', unlockEndHandler, false);
        var elem = document.getElementById(`${zone.uid}index${zone.index}`).classList;
        var element = document.getElementById(`${zone.uid}index${zone.index}`);
        if (elem[3] === 'device-on') {
            element.classList.remove('device-on');
            element.classList.add('device-off');
        }

        var sp = document.getElementById(`${zone.uid}span${zone.index}`).classList;
        var span = document.getElementById(`${zone.uid}span${zone.index}`);
        if (sp[9] === 'successBorder') {
            span.classList.remove('successBorder');
            span.classList.add('dangerBorder');
        }
    }, [zone])

    const unlockEndHandler = () => {
        setValue(0);
        sendCommand();
    }

    // const learnCommand = () => {
    //     sendWidgetCommand(zone.commands[1]['command'], zone.uid);
    //     const zoneId = new FormData();
    //     zoneId.append('zone', selectedZone);
    //     zoneWidgets(zoneId, token)
    //         .then((res) => {
    //             dispatch(setZoneWidgets(res.data.data));
    //         })
    //         .catch((err) => console.log(err))
    // }

    const sendCommand = () => {
        setValue(0);
        var sp = document.getElementById(`${zone.uid}span${zone.index}`).classList;
        if (sp[9] === 'successBorder') {
            setShowFreezing(true);
            var command = zone.commands[0]['command'] + zone.commands[0]['argument'];
            sendWidgetCommand(command, zone.uid);
            setTimeout(() => {
                setShowFreezing(false);
            }, 1000);
        }
    }

    const hideUnhideWideget = () => {
        setHideWidget(!hideWidget)
    }

    return (
        <>
            <ModalComp
                modal={openKeyLampModal}
                toggle={toggleKeyLamp}
                component={<KeyLamp />}
            // component={<Schedule />}
            />
            <ModalComp
                modal={openCommandsModal}
                toggle={toggleCommands}
                component={<WidgetCommands zone={zone} />}
            />
            <ModalComp
                modal={openScheduleListModal}
                toggle={toggleScheduleList}
                component={<ScheduleList zone={zone} />}
            />
            <ModalComp
                modal={openEditModal}
                toggle={toggleEdit}
                component={<EditWidget zone={zone} toggleEdit={toggleEdit} />}
            />
            <ModalComp
                modal={openMoveModal}
                toggle={toggleMove}
                component={<MoveWidget zone={zone} toggleMove={toggleMove} />}
            />
            <ModalComp
                modal={openInfoModal}
                toggle={toggleInfo}
                component={<InfoWidget zone={zone} toggleInfo={toggleInfo} />}
            />
            <ModalComp
                modal={openDeviceInfoModal}
                toggle={toggleDeviceInfo}
                component={<DeviceInfo toggleDeviceInfo={toggleDeviceInfo} />}
            />
            <ModalComp
                modal={openLearnModal}
                toggle={toggleLearn}
                component={<LearnWidget sendWidgetCommand={sendWidgetCommand} zone={zone} toggleLearn={toggleLearn} />}
            />
            <ModalComp
                modal={widgetSettingOpen}
                toggle={toggleWidgetSetting}
                component={<WidgetSetting zone={zone}
                    toggleCommands={toggleCommands}
                    toggleScheduleList={toggleScheduleList}
                    toggleEdit={toggleEdit}
                    toggleInfo={toggleInfo}
                    toggleLearn={toggleLearn}
                    toggleDeviceInfo={toggleDeviceInfo}
                    toggleMove={toggleMove} />}
                dark={true}
            />
            <div className={`device w-100 p-3 device-off`} id={`${zone.uid}index${zone.index}`}>
                <div className="d-flex align-items-center justify-content-between">
                    <i
                        id={`${zone.uid}span${zone.index}`}
                        className={`deviceCircle dangerBorder d-flex align-items-center cursor justify-content-center text-center 
                        ${zone.serial === health.serial && health.health[zone.index] === 1 || health.health[zone.index] === 2 ? 'bg-activeDevice text-white' : 'bg-deactiveDevice text-dark'} 
                        ${zone.uid}`}>
                        {zone.property[2] !== 'image_path' ?
                            <img src={zone.property[2]} className="w-75" />
                            :
                            <FaQuestion />
                        }
                    </i>
                    {showAll && zone.property[3] === '0' ?
                        <FaEyeSlash />
                        :
                        showAll && zone.property[3] === '1' ?
                            <FaEye />
                            :
                            ''
                    }

                </div>
                <div className="fn widgets pt-2">
                    <b className="m-0 fn12" onClick={openKeyLamp}>{zone.caption}</b>
                </div>
                {zone.commands[1].didactic === true ?
                    <small className="fn10 d-block pb-1 pt-2">نیازمند لرن</small>
                    :
                    <small
                        id={`${zone.uid}text${zone.index}`}
                        className="fn10 d-block pb-1 pt-2">لرن شده</small>
                }                <div>
                    <i
                        className="icon-ellipsis-vert p-1 detailIconRotate cursor"
                        onClick={toggleWidgetSetting}>
                    </i>
                </div>
                <div className="mt-2">
                    <div>
                        <input type="range" ref={radioinput} value={value}
                            onClick={sendCommand}
                            className="radioRange shadow"
                            onChange={(e) => setValue(value + 10)
                            }
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export { WidgetRadio };